import React from "react";
import { ArrowRight, TrendingUp } from "lucide-react";
import heroBackground from "../assets/263.jpg";
import "./Hero.css";
import { useNavigate } from "react-router-dom";

const Hero = () => {

  const navigate = useNavigate()
  return (
    <section className="hero-section">

      <div
        className="hero-bg"
        style={{ backgroundImage: `url(${heroBackground})` }}
      />

      <div className="hero-overlay" />

      <div className="hero-content">

        <div className="highlight highlight44444">
          <TrendingUp className="icon-left" />
          <span>$3B+ in Transactions Arranged</span>
        </div>

        <h1 className="hero-title">
          Transforming Africa,<br />
          <span className="text-accent">One Business at a Time</span>
        </h1>

        <p className="hero-subtitle">
          Arranging specialized financial solutions that empower African economies through
          distinctive expertise and global reach.
        </p>

        <div className="hero-buttons">
          <button
            className="btn-hero-primary"
            onClick={() =>
              document.getElementById("about")?.scrollIntoView({ behavior: "smooth" })
            }
          >
            Our Impact <ArrowRight className="icon-right" />
          </button>

          <button
            className="btn-hero-outline"
            onClick={() =>
              navigate("/contact")
            }
          >
            Get in Touch
          </button>
        </div>

      </div>

      <div className="scroll-indicator">
        <div className="mouse">
          <div className="scroller"></div>
        </div>
      </div>

    </section>
  );
};

export default Hero;
